module.exports = __webpack_public_path__ + "media/images/iconTrendDown__inFrontOfAccent-b7cfeb8c206362d95d733094ff16bd1e.png";